import { Snackbar } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import MuiAlert from "@material-ui/lab/Alert";
import { IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";
import CustomSelect from "components/CustomSelect/CustomSelect";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { LoginContext } from "contexts/LoginContext";
import { useContext, useEffect, useState } from "react";
import getStudentDetailsByEmail from "services/ApplicationUser/getStudentDetailsByEmail";
import updateEnquiry from "services/EnquiryService/UpdateEnquiry";
import GetAllPrograms from "services/ProgramServices/GetAllPrograms";
import createUserEnrollment from "services/UserProgramEnrollmentService/createEnrollment";
import AddPaymentModal from "./AddPaymentModal";


function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function EnquiryConvertModal({ enquiry, onClose, afterConvert }) {
    const { user } = useContext(LoginContext);
    console.log("enquiry", enquiry);
    const [programs, setPrograms] = useState([]);
    const [programBatches, setProgramBatches] = useState([]);
    const [selectedProgramBatchId, setSelectedProgramBatchId] = useState(0);
    const [selectedProgramId, setSelectedProgramId] = useState(enquiry?.programId || 0);
    const [name, setName] = useState(enquiry?.name || "");
    const [email, setEmail] = useState(enquiry?.email || "");
    const [mobile, setMobile] = useState(enquiry?.mobile || "");
    const [totalFee, setTotalFee] = useState(0);
    const [open, setOpen] = useState(false);
    const [enableSlabs, setEnableSlabs] = useState(false);
    const [slabs, setSlabs] = useState([]);
    const [isAutoDistributed, setIsAutoDistributed] = useState(true);
    const [isLoading, setLoading] = useState(false);



    const [severity, setSeverity] = useState("success");
    const [alertMessage, setAlertMessage] = useState("");
    const [step, setStep] = useState(1);
    const [convertedData, setConvertedData] = useState(null);
    const [discountPercent, setDiscountPercent] = useState(0);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [discountError, setDiscountError] = useState("");


    // useEffect(() => {
    //     if (discountPercent > 0 && totalFee > 0) {
    //         const dAmount = (totalFee * discountPercent) / 100;
    //         setDiscountAmount(dAmount);
    //     } else {
    //         setDiscountAmount(0);
    //     }
    // }, [discountPercent, totalFee]);

    // const finalPayable = totalFee - discountAmount;
    const finalPayable = Math.max(totalFee - discountAmount, 0);



    useEffect(() => {
        const fetchPrograms = async () => {
            const res = await GetAllPrograms.getAllPrograms();
            const data = res?.$values?.length > 0 ? res?.$values : [];
            console.log('dataresp - ', data);
            const filterData = data.map(p => ({
                id: p.programId,
                name: p.name,
                baseFee: p.baseFee,
                batches: p?.batches?.$values?.length > 0 ? p?.batches?.$values : [],
                slabs: (p.slabs?.$values || []).map(s => ({
                    slabName: s.name,
                    amount: Number(s.amount),
                    durationInMonths: Number(s.durationInMonths),
                    sequenceOrder: s.sequenceOrder,
                }))
            }));
            setPrograms(filterData);
            // If enquiry already has a program selected, set totalFee to its baseFee
            console.log(enquiry?.programId);
            if (enquiry?.programId) {
                const selectedProgram = filterData?.find(p => p.id === enquiry?.programId);
                console.log("abcd", selectedProgram);
                if (selectedProgram) {
                    setSelectedProgramId(selectedProgram?.id);
                    setTotalFee(selectedProgram?.baseFee);
                }
            }
        };
        fetchPrograms();
    }, []);
    useEffect(() => {
        if (!programs.length || !selectedProgramId) return;

        const program = programs.find(p => p.id === selectedProgramId);
        if (!program) return;

        setTotalFee(program.baseFee);
        if (program?.batches?.length > 0) {
            console.log(program);
            let batches = program?.batches?.map((batch) => ({
                id: batch?.programBatchId,
                name: batch?.batchName,
            }))
            setProgramBatches(batches);
        }
        else {
            setProgramBatches([{ id: 0, name: "N/A" }]);
            setSelectedProgramBatchId(0);
        }
        if (program.slabs?.length > 0) {
            setSlabs(program.slabs);
            setEnableSlabs(true);
            setIsAutoDistributed(false); // backend slabs
        } else {
            setSlabs([]);
            setEnableSlabs(false);
            setIsAutoDistributed(true);
        }
    }, [programs, selectedProgramId]);

    useEffect(() => {
        if (!enableSlabs || !isAutoDistributed || slabs.length === 0) return;

        const perSlab = Math.floor(finalPayable / slabs.length);
        const remainder = finalPayable % slabs.length;

        const distributed = slabs.map((s, i) => ({
            ...s,
            amount: i === 0 ? perSlab + remainder : perSlab,
        }));

        setSlabs(distributed);
    }, [finalPayable, slabs.length]);


    useEffect(() => {
        console.log("ids are ", selectedProgramId, " ", totalFee);
    }, [selectedProgramId]);

    const showSnackBar = (message, sev = "success") => {
        setSeverity(sev);
        setAlertMessage(message);
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") return;
        setOpen(false);
        setAlertMessage(null);
    };

    const validateDiscount = (value) => {
        if (value === "" || value === null) {
            setDiscountError("");
            setDiscountAmount(0);
            return;
        }

        const num = Number(value);

        if (isNaN(num)) {
            setDiscountError("Invalid discount amount. Please enter a number.");
            return;
        }

        if (num < 0) {
            setDiscountError("Discount cannot be negative. Enter a valid amount.");
            return;
        }

        if (num > totalFee) {
            setDiscountError(`Discount amount cannot exceed total fee (₹${totalFee}).`);
            return;
        }

        setDiscountError("");
        setDiscountAmount(num);
    };


    const handleConvert = async () => {

        console.log("dataa", selectedProgramId, "   ", totalFee)
        if (!selectedProgramId || totalFee <= 0) {
            showSnackBar("Please select program and enter valid total fee", "error");
            return;
        }
        if (discountError) {
            showSnackBar("Please fix discount errors before proceeding.", "error");
            return;
        }


        try {
            // if (enableSlabs) {
            //     const slabTotal = slabs.reduce((sum, s) => sum + s.amount, 0);

            //     if (slabTotal !== finalPayable) {
            //         showSnackBar(
            //             `Slab total (${slabTotal}) must equal final payable (${finalPayable})`,
            //             "error"
            //         );
            //         return;
            //     }

            // }

            const duplicateCheck = await getStudentDetailsByEmail.getStudentDetailByEmail(email);

            if (duplicateCheck?.status === 400) {
                setLoading(false);
                showSnackBar(duplicateCheck?.messege || "User already exists with this email. Duplicate entry not allowed.", "error");
                return;
            }

            if (enableSlabs && slabs.length > 0) {
                const slabTotal = slabs.reduce((sum, s) => sum + s.amount, 0);
                if (slabTotal !== finalPayable) {
                    showSnackBar(
                        `Slab total (${slabTotal}) must equal final payable (${finalPayable})`,
                        "error"
                    );
                    return;
                }
            }


            setLoading(true);
            // Step 1: Create Enrollment + User
            const enrollmentData = {
                name: name,
                email: email,
                mobile: mobile,
                batch: selectedProgramBatchId == 0 ? null : selectedProgramBatchId,
                programId: selectedProgramId,
                totalFee: finalPayable,
                // discountPercent,
                discountAmount,
                FeeSlabList: enableSlabs ? slabs : [],
                createdBy: user ?? "system",
            };
            const enrollmentRes = await createUserEnrollment(enrollmentData);
            console.log("enrllemntdata", enrollmentRes);
            // Step 2: Update Enquiry as Converted
            if (enrollmentRes) {
                const enquiryUpdateData = {
                    status: "Converted",
                    convertedUserId: enrollmentRes?.userId,
                    updatedBy: user ?? "system",
                };
                await updateEnquiry(enquiry?.enquiryid, enquiryUpdateData);

            }
            setLoading(false);
            showSnackBar(`Admission successfully created for ${name}`, "success");
            // afterConvert && afterConvert();
            // onClose();
            setConvertedData({
                convertedUserId: enrollmentRes.userId,
                programId: selectedProgramId,
                totalFee,
            });
            setTimeout(() => {
                setStep(2);
            }, 3000);
        } catch (err) {
            setLoading(false);
            console.error(err);
            showSnackBar("Unable to convert enquiry. Please check mandatory details ", "error");    //+ (err.message || err)
        }
    };
    // 
    const handleAddSlab = () => {
        setEnableSlabs(true);
        setIsAutoDistributed(true);

        setSlabs(prev => [
            ...prev,
            {
                slabName: `Installment ${prev.length + 1}`,
                amount: 0,
                durationInMonths: 0,
                sequenceOrder: prev.length + 1,
            },
        ]);
    };

    const handleRemoveSlab = (index) => {
        setSlabs(prev => prev.filter((_, i) => i !== index));
    };


    return (
        <>
            {step === 1 && (
                <Card>
                    <CardHeader color="rose" icon>
                        <CardIcon color="rose">
                            <i className="material-icons">person_add</i>
                        </CardIcon>
                        <h4>Convert Enquiry to Student</h4>
                    </CardHeader>
                    <CardBody>
                        <GridContainer spacing={3}>
                            <GridItem xs={12} sm={6}>
                                <CustomInput
                                    labelText="Name"
                                    id="name"
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                    inputProps={{
                                        name: "name",
                                        value: name,
                                        onChange: (e) => {
                                            setName(e?.target?.value)
                                        }
                                    }}
                                // disabled
                                />
                            </GridItem>
                            <GridItem xs={12} sm={6}>
                                <CustomInput
                                    labelText="Email"
                                    id="email"
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                    inputProps={{
                                        name: "email",
                                        value: email,
                                        onChange: (e) => {
                                            setEmail(e?.target?.value)
                                        }
                                    }}
                                // disabled
                                />
                            </GridItem>
                            <GridItem xs={12} sm={4}>
                                <CustomInput
                                    labelText="Mobile"
                                    id="mobile"
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                    inputProps={{
                                        name: "mobile",
                                        value: mobile,
                                        onChange: (e) => {
                                            setMobile(e?.target?.value)
                                        }
                                    }}
                                // disabled
                                />
                            </GridItem>
                            <GridItem xs={12} sm={4}>
                                <CustomSelect
                                    label="Program"
                                    id="Program"
                                    name="Program"
                                    options={programs}
                                    // setvalue={v => {
                                    //     setSelectedProgramId(v);

                                    //     const selectedProgram = programs.find(p => p.id === v);
                                    //     if (selectedProgram) {
                                    //         setTotalFee(selectedProgram.baseFee);
                                    //         setSlabs(selectedProgram.slabs); // load slabs
                                    //         setEnableSlabs(selectedProgram.slabs?.length > 0);
                                    //     } else {
                                    //         setTotalFee(0);
                                    //         setSlabs([]);
                                    //     }
                                    // }}
                                    setvalue={v => {
                                        setSelectedProgramId(v);

                                        const program = programs.find(p => p.id === v);
                                        if (!program) return;

                                        setTotalFee(program.baseFee);

                                        if (program.slabs?.length > 0) {
                                            // Program already has slabs
                                            setSlabs(program.slabs);
                                            setEnableSlabs(true);
                                            setIsAutoDistributed(false); // backend-controlled
                                        } else {
                                            // No slabs → do nothing
                                            setSlabs([]);
                                            setEnableSlabs(false);
                                            setIsAutoDistributed(true);
                                        }
                                    }}


                                    value={selectedProgramId}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={4}>
                                <CustomSelect
                                    label="Program Batch"
                                    id="Programbatch"
                                    name="ProgramBatch"
                                    options={programBatches}
                                    setvalue={v => {
                                        setSelectedProgramBatchId(v);
                                    }}

                                    disabled={programBatches?.length === 1 && programBatches[0].name === "N/A"}
                                    value={selectedProgramBatchId}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={3}>
                                <CustomInput
                                    labelText="Total Fee"
                                    id="totalfee"
                                    type="number"
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                    inputProps={{
                                        name: "totalfee",
                                        value: totalFee,
                                        onChange: (e) => {
                                            setTotalFee(Number(e.target.value))
                                        }
                                    }}
                                />
                            </GridItem>
                            {/* <GridItem xs={12} sm={3}>
                                <CustomInput
                                    labelText="Discount Amount"
                                    disabled
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                    inputProps={{
                                        value: discountAmount,
                                    }}
                                />
                            </GridItem> */}
                            <GridItem xs={12} sm={3}>
                                <CustomInput
                                    labelText="Discount Amount (₹)"
                                    id="discountAmount"
                                    type="number"
                                    formControlProps={{
                                        fullWidth: true,
                                        error: !!discountError
                                    }}
                                    inputProps={{
                                        value: discountAmount,
                                        onChange: (e) => validateDiscount(e.target.value),
                                        min: 0
                                    }}
                                />
                                {discountError && (
                                    <span style={{ color: "red", fontSize: "12px" }}>
                                        {discountError}
                                    </span>
                                )}
                            </GridItem>

                            {/* <GridItem xs={12} sm={3}>
                                <CustomInput
                                    labelText="Discount (%)"
                                    type="number"
                                    formControlProps={{
                                        fullWidth: true,
                                    }}
                                    inputProps={{
                                        value: discountPercent,
                                        onChange: e => setDiscountPercent(Number(e.target.value)),
                                    }}
                                />
                            </GridItem> */}
                            <GridItem xs={12} sm={3}>
                                <h4 style={{ marginTop: '30px' }}>Final Payable: ₹{finalPayable}</h4>
                            </GridItem>

                        </GridContainer>
                        <GridContainer justifyContent="space-between">

                            <GridItem xs={12} sm={6}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={enableSlabs}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                setEnableSlabs(checked);

                                                if (!checked) {
                                                    // user does NOT want slabs
                                                    setSlabs([]);
                                                    setIsAutoDistributed(true);
                                                } else {
                                                    // user wants slabs but none exist yet
                                                    if (slabs.length === 0) {
                                                        setSlabs([
                                                            {
                                                                slabName: "Installment 1",
                                                                amount: finalPayable,
                                                                durationInMonths: 0,
                                                                sequenceOrder: 1,
                                                            },
                                                        ]);
                                                        setIsAutoDistributed(false);
                                                    }
                                                }
                                            }}
                                        />
                                    }
                                    label="Do you want to create slabs?"
                                />
                            </GridItem>

                            {
                                enableSlabs && (
                                    <GridItem xs={12} sm={6}>
                                        {/* <h4>Payment Slabs</h4> */}
                                        <Button color="primary" onClick={handleAddSlab}>
                                            + Add Slab
                                        </Button>
                                    </GridItem>)
                            }
                        </GridContainer>

                        {enableSlabs && slabs.map((slab, index) => (
                            <GridContainer key={index} spacing={2}>
                                <GridItem xs={3}>
                                    <CustomInput
                                        labelText="Slab Name"
                                        inputProps={{
                                            value: slab.slabName,
                                            onChange: e => {
                                                setIsAutoDistributed(false);
                                                const updated = [...slabs];
                                                updated[index].slabName = e.target.value;
                                                setSlabs(updated);
                                            }
                                        }}
                                    />
                                </GridItem>

                                <GridItem xs={3}>
                                    <CustomInput
                                        labelText="Amount"
                                        type="number"
                                        inputProps={{
                                            value: slab.amount,
                                            onChange: e => {
                                                setIsAutoDistributed(false);
                                                const updated = [...slabs];
                                                updated[index].amount = Number(e.target.value);
                                                setSlabs(updated);
                                            }
                                        }}
                                    />
                                </GridItem>

                                <GridItem xs={3}>
                                    <CustomInput
                                        labelText="Duration (After Months)"
                                        type="number"
                                        inputProps={{
                                            value: slab.durationInMonths,
                                            onChange: e => {
                                                setIsAutoDistributed(false);
                                                const updated = [...slabs];
                                                updated[index].durationInMonths = Number(e.target.value);
                                                setSlabs(updated);
                                            }
                                        }}
                                    />
                                </GridItem>
                                <GridItem xs={3}>
                                    <IconButton
                                        // color="danger"
                                        // size="sm"
                                        onClick={() => handleRemoveSlab(index)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>

                                </GridItem>

                            </GridContainer>
                        ))}


                        <Button
                            color="rose"
                            style={{ float: "right", marginTop: 20 }}
                            onClick={handleConvert}
                            disabled={isLoading}
                        >
                            {isLoading ? 'loading...' : 'Confirm Admission'}
                        </Button>
                    </CardBody>
                    <Snackbar
                        open={open}
                        autoHideDuration={2000}
                        onClose={handleClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    >
                        <Alert onClose={handleClose} severity={severity}>
                            {alertMessage}
                        </Alert>
                    </Snackbar>
                </Card>
            )}
            {step === 2 && (
                <AddPaymentModal
                    enquiry={{
                        convertedUserId: convertedData?.convertedUserId,
                        programId: convertedData?.programId,
                    }}
                    onClose={onClose}
                    onSuccess={() => {
                        afterConvert && afterConvert();
                        onClose();
                    }}
                />
            )}
        </>
    );
}
